import type { FlowEdge, FlowNode } from '@lighthouse/shared'
import { NODE_CARD_WIDTH } from '@lighthouse/shared'
import { useReactFlow } from '@xyflow/react'
import produce from 'immer'
import { useCallback } from 'react'

import { useFlowContainerContext } from '@/contexts/FlowContext'

import { getLayoutByDagre } from '../utils/layoutNode'

export const useLayout = () => {
    const { getNodes, setNodes, getEdges } = useReactFlow<FlowNode, FlowEdge>()
    const { log } = useFlowContainerContext()
    const handleLayout = useCallback(() => {
        if (log) {
            return
        }
        const edges = getEdges()
        const nodes = getNodes()
        const layout = getLayoutByDagre(nodes, edges)

        const rankMap = {} as Record<string, FlowNode>
        nodes.forEach(node => {
            const { rank = 0 } = layout.node(node.id)

            if (rankMap[rank]) {
                if (rankMap[rank].position.y > node.position.y) {
                    rankMap[rank] = node
                }
            } else {
                rankMap[rank] = node
            }
        })

        const newNodes = produce(nodes, draft => {
            draft.forEach(node => {
                const nodeWithPosition = layout.node(node.id)
                const offsetX = (node.measured?.width ?? 0) / 2
                const offsetY = (node.measured?.height ?? 0) / 2
                const rankHeight = (rankMap[nodeWithPosition?.rank ?? 0].measured?.height ?? 0) / 2
                node.position = {
                    x: nodeWithPosition.x - offsetX,
                    y: nodeWithPosition.y - offsetY + rankHeight
                }
            })
        })
        setNodes(newNodes)
    }, [getEdges, getNodes, log, setNodes])
    return {
        handleLayout
    }
}
